import {
  format,
  formatDuration as dtFormatDuration,
  formatDistanceToNow,
} from "date-fns";

function timeago(val) {
  return formatDistanceToNow(new Date(val), { addSuffix: true });
}

function formatDate(val) {
  // return format(new Date(val), "dd-MM-yyyy, HH:mm xxx");
  return format(new Date(val), "dd-MM-yyyy, p");
}

function formatTime(val) {
  // return format(new Date(val), "dd-MM-yyyy, HH:mm xxx");
  return format(new Date(val), "HH:mm");
}

function formatDateOnly(val) {
  // return format(new Date(val), "dd-MM-yyyy, HH:mm xxx");
  return format(new Date(val), "dd-MM-yyyy");
}

function formatName(val) {
  return val
    .toLowerCase()
    .split(" ")
    .map((v) => v.substr(0, 1).toUpperCase() + v.substr(1))
    .join(" ");
}

function formatDuration(val) {
  return dtFormatDuration({ seconds: parseInt(val) }, { format: ["minutes"] });
}

function formatNameForIcon({ first_name, last_name }) {
  if (first_name && last_name)
    return `${first_name.substr(0, 1).toUpperCase()}${last_name
      .substr(0, 1)
      .toUpperCase()}`;
}

export {
  timeago,
  formatTime,
  formatDate,
  formatDateOnly,
  formatDuration,
  formatNameForIcon,
  formatName,
};
